import React, { Component } from "react"
import { connect } from "react-redux"
import MetaTags from "react-meta-tags"
import { Button, Card, CardBody, CardText, Col, Container, Label, Row, UncontrolledTooltip } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { AvField, AvForm } from "availity-reactstrap-validation"
import { copyToClipboard, showSuccessMessage } from "../../../helpers/utils"
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

// const re = /((^[\w\.]+id\d{1,}+[\w]{0,})|(^id\d{1,}+[\w]{0,}))/

const re =
  /(^[\w\.]+id(\d{1,})+[\w]{0,})|((^id\d{1,})+[\w]{0,})/

class CampaignValidator extends Component {

  state = {
    isValid: false,
    value: '',
    campaign_id: false,
    isCopy: false,
  }

  onChange = e => {
    const value = e.target.value

    const isValid = String(value)
      .match(re)

    let campaign_id = String(value).match(/id\d{1,}/)
    campaign_id = !!campaign_id ? campaign_id[0] : false

    this.setState({ isValid, value, campaign_id })
  }

  handleCopy = () => {
    if (!this.state.isValid) return void 0;
    console.log(this.state.value)

    copyToClipboard(this.state.value)
    showSuccessMessage('Token copied successfully!')

    // navigator.clipboard.writeText(this.state.value)
    //   .then(() => {
    //     showSuccessMessage('Token copied successfully!')
    //   })
    //   .catch(() => {
    //     showErrorMessage('Something went wrong! Please, copy token from input')
    //   })
  }

  onClickCopyCampaignId = () => {
    copyToClipboard(this.state.campaign_id)
    showSuccessMessage('Campaign id copied successfully!!')
    this.setState({isCopy: true})

    setTimeout(() => {
      this.setState({isCopy: false})
    }, 2000)
  }

  render() {
    const {} = this.props

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Campaign validator" />

          <Container fluid>
            <Breadcrumbs title="Dashboard" breadcrumbItem="Campaign validator" link="/dashboard" />
            <Row className="justify-content-center">
              <Col xl={4} lg={6} md={8} sm={12}>
                <Card>
                  <CardBody>
                    <CardText className="font-weight-semibold">Campaign validator</CardText>
                    <AvForm onChange={this.onChange}>
                      <Label>
                        Token:{" "}
                        <i
                          className="dripicons-question"
                          id="token-help"
                          style={{verticalAlign: "-2.5px", color: '#5580ff'}}
                        />
                        <UncontrolledTooltip
                          placement="auto"
                          autohide={false}
                          target="token-help"
                        >
                          <p className="mb-0 text-start">1. Must contain id.</p>
                          <p className="text-start">Example: id1234567890</p>
                          <p className="mb-0 text-start">2. Should be no spaces</p>
                        </UncontrolledTooltip>
                      </Label>
                      <AvField
                        name="token"
                        // label={label}
                        type="text"
                        errorMessage="Invalid token"
                        placeholder="Enter token..."
                        // pattern={/((^[w.]+idd{1,}/+/[w]{0,})|(^idd{1,}/+/[w]{0,}))/}
                        // pattern={"^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$"}
                        // pattern={re}
                        validate={{
                          required: { value: true, errorMessage: "This field is required!" },
                          pattern: { value: re, errorMessage: "Token is not valid!" }
                          // minLength: {value: 6},
                          // maxLength: {value: 16}
                        }} />
                    </AvForm>
                    <div className="text-start d-flex mt-3">
                      <Button
                        color={this.state.isValid ? "success" : 'secondary'}
                        // type="submit"
                        disabled={!this.state.isValid}
                        className={`float-start`}
                        onClick={this.handleCopy}
                      >Copy</Button>
                      {this.state.campaign_id && <div className="d-inline-flex align-items-center ms-3">{this.state.campaign_id}
                        <span onClick={this.onClickCopyCampaignId}><i
                          className={`ms-1 ${!this.state.isCopy ? "bx bx-copy" : "mdi mdi-check-bold"}`} /></span>
                      </div>}
                    </div>
                    <div className="mt-4">
                      <p>{this.state.value}</p>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignValidator)
